import { PartialRemoteConfigMap } from '@/config/utils'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type RemoteConfigState = {
  values: PartialRemoteConfigMap
}

const initialState: RemoteConfigState = {
  values: {},
}

const remoteConfigSlice = createSlice({
  name: 'REMOTE_CONFIG_SLICE',
  initialState,
  reducers: {
    setRemoteConfig: (state, action: PayloadAction<PartialRemoteConfigMap>) => {
      state.values = {
        ...state.values,
        ...action.payload,
      }
    },
    resetRemoteConfig: (state) => {
      state.values = {}
    },
  },
})

export const { setRemoteConfig, resetRemoteConfig } = remoteConfigSlice.actions
export default remoteConfigSlice.reducer
